(ns ycweb.app.website.voucher.preview
  (:require
   #?@(:cljs
       [[ajax.core :as ajax]])
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.voucher.common :as common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

(defn addtocart
  [app-atom process-atom
   {:voucher/keys
    [value message buyeremail buyeremailcheck qty email confirmemail
     voucher-id futuredate cover] :as voucher}
   params]
  #?(:cljs
     (cond
       ;; Use new cart API with clean nested structure
       (cmn/curact app-atom [:features :new-cart])
       (let [cartitem-uuids (:cartitem/uuids @process-atom)
             voucher-data
             {:amount (* value 100)
              :qty (u/parseInt (or qty 1))
              :cartitem_uuids cartitem-uuids
              :cover
              {:id (:cover/id cover)
               :method (:voucher/method voucher)
               :recipient_email (if (= (:voucher/method voucher) "email") email buyeremail)
               ;; TODO: interface doesn't have this.
               :recipient_name (or (:voucher/recipient-name voucher) "")
               :sender_email buyeremail
               :sender_name (or (:voucher/name voucher) "")
               :message (or message "")
               :send_date futuredate
               :future_send (= (:voucher/send voucher) "future")}}]

         (cond
           cartitem-uuids
           (do
             (toaster/open-toast app-atom :processing "Updating voucher" {:closetime 15000})
             (model/update-voucher app-atom cartitem-uuids voucher-data
               (fn [response]
                 (toaster/close-toast app-atom)
                 (swap! (cmn/process-cursor app-atom) assoc :page-type :cart)
                 (urlstate/redirect app-atom "order" "ShowCart" {}))))

           :else
           (do
             (toaster/open-toast app-atom :processing "Adding to your cart" {:closetime 15000})
             (model/add-voucher app-atom voucher-data
               (fn [response]
                 (toaster/close-toast app-atom)
                 (swap! (cmn/process-cursor app-atom) assoc :page-type :cart)
                 (urlstate/redirect app-atom "order" "ShowCart" {}))))))

       ;; Fall back to existing PHP implementation
       :else
       (let [data (js/FormData.)]
         (toaster/open-toast app-atom :processing "Adding to your cart" {:closetime 15000})
         (.append data "SPA" true)
         (.append data "method" (:voucher/method voucher))
         (.append data "coverid" (:cover/id cover))
         (.append data "conf[value]" value)
         (.append data "conf[message]" (or message ""))
         (.append data "conf[buyeremail]" buyeremail)
         (.append data "conf[buyeremailcheck]" buyeremailcheck)
         (.append data "conf[qty]" qty)
         (.append data "conf[email]" email)
         (.append data "conf[emailcheck]" confirmemail)
         (.append data "conf[send]" (:voucher/send voucher))
         (when (u/presence (:voucher/name voucher))
           (.append data "conf[name]" (:voucher/name voucher)))
         (when (u/presence futuredate)
           (.append data "conf[futuredate]" (ud/date-format futuredate "dd MMM YYYY")))
         (when (u/presence voucher-id)
           (.append data "conf[voucheredit]" voucher-id))

         (ajax/POST
           "/gift-vouchers.htm?action=AddVoucherToCart&overrideincludes=ajax"
           {:body data
            :response-format :json
            :keywords? true
            :handler
            (fn [res]
              (if (:success res)
                (set! js/window.location "/order.htm?action=ShowCart")
                (do
                  (toaster/close-toast app-atom)
                  (grid/open-modal app-atom :web.preview/error
                    {:config
                     {:title "Something went wrong"
                      :message (get-in res [:assign :message])}}))))
            :error-handler
            (fn [res]
              (toaster/close-toast app-atom)
              (grid/open-modal app-atom :web.preview/error
                {:config
                 {:title "Something went wrong"
                  :message (get-in res [:assign :message])}}))
            :timeout 60000})))))

(rum/defc preview-error-body < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)
        message (:message config)]

    [:<>
     (headings/heading "There's a problem with the voucher." {:type :h2 :size :default})

     (cond
       message
       [:p.yc-paragraph message]

       :else
       [:p.yc-paragraph "We didn't manage to add this item to your cart. Please try again, or "
        [:a {:href "contact.htm"} "contact us"]
        " for help."])]))

(rum/defc preview-error-footer < rum/reactive [app-atom]
  (list
    (grid/button-row
      {:single-text "Close"
       :single-style :secondary
       :single-fn #(grid/close-modal app-atom)})))

(defmethod grid/modal-config :web.preview/error [app-atom config _]
  {:body preview-error-body
   :footer preview-error-footer
   :modal-type :variable})

(rum/defc voucher-preview < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        {:voucher/keys [method value email message cover] :as voucher} (rum/react voucher-atom)
        email? (= "email" method)
        digital-voucher-details (cmn/curact process-atom :digital-voucher-details)]

    [:div
     {:class (u/bem :yc-page-content [:standard])}
     (common/process-bar app-atom
       {:title "Preview your voucher"
        :step 3
        :action "createvoucher"
        :printable? true})
     [:div
      {:class (u/bem :yc-section [:standard])}
      [:div.voucher-preview.u-max-width-480.u-block-center

       (when email?
         [:div.voucher-preview__header
          [:p
           {:class (u/bem :yc-paragraph [:flush])}
           [:b "To:"]
           (str " " email)]
          [:p.yc-paragraph
           [:b "Subject:"]
           (str " " (:voucher/name voucher) " has sent you a Yuppiechef Gift Voucher")]])

       [:div.voucher-preview-image
        (if email?
          (web-common/lazy-image app-atom
            (:doc/public-id (:ent/image cover))
            {:class ["yc-simple-image  yc-simple-image--full"]}
            {:w 480
             :dpr 2
             :c "lpad"
             :q "auto"})
          (web-common/lazy-image app-atom
            "pages/gift-vouchers/printed-voucher-preview.jpg"
            {:class ["yc-simple-image  yc-simple-image--full"]}
            {:h 410 :w 480 :c "scale"
             :effect "distort:59:32:429:65:390:353:35:278"
             :overlay (:doc/public-id (:ent/image cover))}))]

       [:p.voucher-preview__value
        [:b "Value:"]
        (str " R" value)]

       [:div.voucher-preview__message
        [:p
         {:class (u/bem :yc-paragraph [:flush])}
         message]]

       [:div.form-control
        (buttons/button-web
          [[:span.clip-text.unclip-text--s "Looks Good, "] "Continue"]
          {:type :button
           :style :primary
           :size :large
           :icon :arrow-right
           :icon-placement :right
           :on-click
           (fn [e]
             (.preventDefault e)
             (addtocart app-atom process-atom voucher
               {:contentid (:digital-voucher/contentid digital-voucher-details)
                :variationid (:digital-voucher/id digital-voucher-details)
                :ownamount value}))})]

       [:a
        (merge
          {:class (u/bem :text-link [:muted])}
          (urlstate/href-props app-atom "gift-vouchers" "editvoucher"
            {:method method
             :coverid (:cover/id cover)}))
        "Edit Voucher"]]
      (toaster/loading-overlay app-atom :web.gift-vouchers/previewvoucher)]]))

(defmethod comms/receive :web.gift-vouchers/get-digital-voucher-details [app-atom e]
  (toaster/close-overlay app-atom :web.gift-vouchers/previewvoucher)
  (swap! (cmn/process-cursor app-atom) assoc :digital-voucher-details (:digital-voucher e)))

(defmethod flow/render-screen :web.gift-vouchers/previewvoucher [app-atom _]
  (website/screen-wrapper app-atom
    (voucher-preview app-atom)
    {}))

(defmethod t/transition-open :web.gift-vouchers/previewvoucher [app-atom _ params]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher (cmn/curact process-atom :voucher)]

    (when (nil? voucher)
      (urlstate/redirect app-atom "gift-vouchers" "createvoucher"
        {:method (:method params)
         :coverid (:coverid params)}))

    (swap! process-atom assoc-in [:voucher :previewed?] true)
    (toaster/open-overlay app-atom :web.gift-vouchers/previewvoucher)
    (comms/ajax-get :web.gift-vouchers/get-digital-voucher-details {})))